import { apiRequest } from './httpClient';

// The TRUE language capabilities of the currently-configured backend
// STT/translation/TTS providers (backend/routers/capabilities.py) —
// Start Meeting / Settings build their language dropdowns from this
// response instead of the static frontend/src/constants/languages.js
// list, which is now only a provider-neutral fallback/helper (see that
// file's comment).
export function getLanguageCapabilities() {
  return apiRequest('/api/capabilities/languages');
}
